<template>

    <van-popup
        v-model="showCamera"
        :close-on-click-overlay="false"
        position="bottom">
        <div class="popup-wrap">
            <div @click="selectJSB" class="popup_item van-hairline--top">扫描识别</div>
            <div class="popup_item van-hairline--top" @click="selectH5">
                拍照/相册
                <div class="popup_h5">
                    <crop-upload ref="caneraH5" :dir="dir" @uploadSuccess="uploadAuth">
                        <div class="popup_h5_space"></div>
                    </crop-upload>
                </div>
            </div>
            <div @click="cancel" class="popup_item popup_cancel">取消</div>
        </div>
    </van-popup>

</template>

<script>
    import { Popup as VanPopup } from 'vant'
    import CropUpload from '@/components/CropUpload/CropUpload.vue'

    export default {
        name: 'CameraType',
        props: {
            showCamera: Boolean,
            dir: String,
            typeIndex: Number,
        },
        methods: {
            selectJSB() {
                this.$emit('update:showCamera', false);
                this.$emit('selectJSB', this.typeIndex)
            },
            selectH5() {
                this.$emit('update:showCamera', false);
            },
            uploadAuth(url) {
                this.$emit('uploadH5Auth', {
                    url: url,
                    typeIndex: this.typeIndex,
                })
            },
            cancel() {
                this.$emit('update:showCamera', false);
            },
        },
        components: { VanPopup, CropUpload }
    }
</script>

<style lang="scss" scoped>
    .popup-wrap {
        background: #f7f8fa;
        .popup_item {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 50px;
            text-align: center;
            position: relative;
            overflow: hidden;
            color: #666;
            background: #ffffff;
        }
        .popup_cancel {
            margin-top: 8px;
        }
        .popup_h5 {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            &_space {
                width: 100vw;
                height: 50px;
            }
        }
    }
</style>
